import { render } from "./ico-cockroach.vue?vue&type=template&id=355d6681&ts=true"
import script from "./ico-cockroach.vue?vue&type=script&lang=ts"
export * from "./ico-cockroach.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__